import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import EmptyData from "../../StyledComponents/Table/EmptyData";

const useStyles = makeStyles({
  iconButton: {
    visibility: "hidden",
    fontSize: "14px",
  },
  tableCell: {
    position: "relative",
    cursor: "pointer",
    "&:hover  $iconButton": {
      visibility: "visible",
    },
  },
  iconButtonActive: {
    position: "absolute",
    top: "50%",
    fontSize: "14px",
    transform: "translateY(-50%)",
    visibility: "visible",
    cursor: "pointer",
  },
  table: {
    minWidth: "100%",
  },
  inputStyle: {
    outline: "none",
    border: "none",
    background: "transparent",
  },
  inputHov: {
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
  },
  tabCon: {
    width: "100%",
    textAlign: "center", 
  },
});

const VendorAccessTable = ({
  vendorList,
  loading,
  formState,
  setFormState,
  selectedVendors, 
  setSelectedVendors,
}) => {
  const classes = useStyles();
  
  const [isSelectedAllVendors, setIsSelectedAllVendors] = useState(false);
  const [headers, setHeaders] = useState({});


  const addVendorInList = (id) => {
    const vendorId = Number(id);
    setSelectedVendors((vendors) => [...vendors, vendorId]);
  };
// Add this useEffect to sync header checkbox with selectedVendors
// useEffect(() => {
//   if (vendorList.length > 0 && selectedVendors.length > 0) {
//     // Check if all vendors in current page are selected
//     const allVendorIds = vendorList.map(vendor => Number(vendor.user_Id));
//     const allSelected = allVendorIds.every(id => selectedVendors.includes(id));
//     setIsSelectedAllVendors(allSelected);
//   } else {
//     // If no vendors selected or no vendor list, uncheck header
//     setIsSelectedAllVendors(false);
//   }
// }, [selectedVendors, vendorList]);

 useEffect(()=>{
    if(vendorList?.length > 0){
      if(selectedVendors?.length === vendorList?.length) {
        setIsSelectedAllVendors(true)
      }
      else {
        setIsSelectedAllVendors(false)
      }
    }
  },[selectedVendors])

  const removeVendorFromList = (id) => {
    const vendorId = Number(id);
    const filteredVendors = selectedVendors?.filter((i) => i !== vendorId);
    setSelectedVendors(filteredVendors);
  };

   const removeAllVendorsFromList = () => {
    setSelectedVendors([]);
  };
  const addAllVendorsInList = () => {
    const vendors = [];
    for (let index = 0; index < vendorList.length; index++) {
      const element = vendorList[index];
      vendors.push(Number(element?.vendor_Code));
    }
    setSelectedVendors(vendors);
  };

  const Sorting = (value) => {
    setFormState((formState) => ({
      ...formState,
      OrderBy: value,
    }));
  };

  const isAscending = (value) => {
    setFormState((formState) => ({
      ...formState,
      isAsc: value,
    }));
  }; 

  useEffect(() => {
    if (vendorList.length > 0) {
      setHeaders({
        VendorCode: "Vendor Code",
        VendorName: "Vendor Name",
        Status: "Status"
      });
    }
  }, [vendorList]);

  return (
    <Grid container style={{ margin: "20px 0px", overflowY: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} mt={0} style={{ width: "0" }}>
        <TableContainer className={classes.tabCon}>
          <Table className={classes.table} size="small">
            <TableHead style={{ position: "sticky", top: -2, zIndex: "1" }}>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30", textAlign:"center"}}>
                  <Checkbox
                    color="secondary"
                    fontSize="small"
                    checked={isSelectedAllVendors}
                    onChange={(event) => {
                      setIsSelectedAllVendors(event.target.checked);
                      event.target.checked
                        ? addAllVendorsInList()
                        : removeAllVendorsFromList();
                    }}
                  />
                </TableCell>
                
                {headers.VendorCode && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      setFormState(prev => ({
                        ...prev,
                        isAsc: !formState?.isAsc,
                        OrderBy: "vendor_Code"
                      }));
                      Sorting("vendor_Code");
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.VendorCode}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          className={`${formState.OrderBy === "vendor_Code"
                            ? classes.iconButtonActive
                            : classes.iconButton
                            }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          className={`${formState.OrderBy === "vendor_Code"
                            ? classes.iconButtonActive
                            : classes.iconButton
                            }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {headers.VendorName && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      setFormState(prev => ({
                        ...prev,
                        isAsc: !formState?.isAsc,
                        OrderBy: "vendor_Name"
                      }));
                      Sorting("vendor_Name");
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.VendorName}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          className={`${formState.OrderBy === "vendor_Name"
                            ? classes.iconButtonActive
                            : classes.iconButton
                            }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          className={`${formState.OrderBy === "vendor_Name"
                            ? classes.iconButtonActive
                            : classes.iconButton
                            }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {headers.Status && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      setFormState(prev => ({
                        ...prev,
                        isAsc: !formState?.isAsc,
                        OrderBy: "status"
                      }));
                      Sorting("status");
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.Status}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          className={`${formState.OrderBy === "status"
                            ? classes.iconButtonActive
                            : classes.iconButton
                            }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          className={`${formState.OrderBy === "status"
                            ? classes.iconButtonActive
                            : classes.iconButton
                            }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            {loading && (
              <CircularProgress style={{ margin: "20px auto", display: "block" }} />
            )}
            <TableBody>
              {vendorList?.length > 0 &&
                vendorList.map((item) => {
                 const isChecked = selectedVendors.includes(Number(item.vendor_Code));

                  return (
                    <TableRow key={item.vendor_Code}>
                      <TableCell style={{ textAlign: "center", width: "5%" }}>
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          checked={isChecked}
                          onChange={(event) => {
                            event.target.checked
                              ? addVendorInList(item.vendor_Code)
                              : removeVendorFromList(item.vendor_Code);
                          }}
                        />
                      </TableCell>
                      
                      {headers.VendorCode && (
                        <TableCell align="center">
                          {(() => {
                            const vendorCode = item?.vendor_Code?.trim();
                            return vendorCode && !vendorCode.startsWith("000") 
                              ? `000${vendorCode}` 
                              : vendorCode;
                          })()}
                        </TableCell>
                      )}

                      {headers.VendorName && (
                        <TableCell align="center">
                          {item?.vendor_Name}
                        </TableCell>
                      )}

                      {headers.Status && (
                        <TableCell align="center">
                          {item?.status ? "Unblocked" : "Blocked"}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {vendorList?.length === 0 && !loading && <EmptyData />}
      </Grid>
    </Grid>
  );
};

export default VendorAccessTable;